<template>
  <div class="apply-form-page pcStyle">
    <Header />
    <div class="apply-form-content">
      <div class="page-content">
        <div class="content-title">{{ i18n.independentMarketing.applyTitle }}</div>
        <div class="form-component">
          <div class="form-list">
            <!-- 企业名称 -->
            <div class="form-item">
              <div class="title">
                <span class="required">*</span>
                <span class="label-text">{{ i18n.independentMarketing.companyName }}</span>
              </div>
              <van-field
                v-model="form.companyName"
                :placeholder="i18n.independentMarketing.common.hintInput"
                maxlength="200"
              />
            </div>

            <!-- 企业税号 -->
            <div class="form-item">
              <div class="title">
                <span class="required">*</span>
                <span class="label-text">{{ i18n.independentMarketing.companyTax }}</span>
              </div>
              <van-field
                v-model="form.dutyParagraph"
                :placeholder="i18n.independentMarketing.common.hintInput"
                maxlength="100"
              />
            </div>

            <!-- 所在国家 -->
            <div class="form-item country-item">
              <div class="title">
                <span class="required">*</span>
                <span class="label-text">{{ i18n.independentMarketing.userCountry }}</span>
              </div>
              <van-field>
                <template #input>
                  <SelectCountry class="form-item-value" />
                </template>
              </van-field>
            </div>

            <!-- 法人姓名 -->
            <div class="form-item">
              <div class="title">
                <span class="required">*</span>
                <span class="label-text">{{ i18n.independentMarketing.legalPerson }}</span>
              </div>
              <van-field v-model="form.name" :placeholder="i18n.independentMarketing.common.hintInput" maxlength="100" />
            </div>

            <!-- 联系人邮箱 -->
            <div class="form-item" :class="{error: emailErrorMsg}">
              <div class="title">
                <span class="required">*</span>
                <span class="label-text">{{ i18n.independentMarketing.contactEmail }}</span>
              </div>
              <van-field
                v-model="form.email"
                :placeholder="i18n.independentMarketing.common.hintInput"
                maxlength="200"
                @input="checkEmail"
              />
              <div class="text-tips">{{ i18n.independentMarketing.contactEmailTips }}</div>
              <div class="error-tips" v-if="emailErrorMsg">{{ emailErrorMsg }}</div>
            </div>

            <!-- 法人身份证件 -->
            <div class="form-item w50">
              <div class="title">
                <span class="required">*</span>
                <span class="label-text">{{ i18n.independentMarketing.corporateIdentity }}</span>
              </div>
              <van-field class="upload-component">
                <template #input>
                  <Uploader @uploadChange="changeIdCard" />
                </template>
              </van-field>
              <div class="text-tips">{{ i18n.independentMarketing.uploadTips }}</div>
            </div>

            <!-- 企业营业执照 -->
            <div class="form-item w50">
              <div class="title">
                <span class="required">*</span>
                <span class="label-text">{{ i18n.independentMarketing.businessLicense }}</span>
              </div>
              <van-field class="upload-component">
                <template #input>
                  <Uploader @uploadChange="changeCompanyCard" />
                </template>
              </van-field>
              <div class="text-tips">{{ i18n.independentMarketing.uploadTips }}</div>
            </div>
          </div>
          <div class="footer-btn">
            <button class="common-btn cancel mr16" @click="cancel">{{ i18n.independentMarketing.common.cancel }}</button>
            <button
              class="common-btn"
              :disabled="confirmBtnDisabled"
              @click="confirm"
            >{{ i18n.independentMarketing.common.submit }}</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import { mapGetters, mapMutations, mapActions } from 'vuex';
  import Header from '../components/Header.vue';
  import Uploader from '../components/Uploader.vue';
  import SelectCountry from '../components/SelectCountry.vue';
  import { applyApi } from '@/api/independentMarketing.js';
  export default {
    components: {
      Header,
      Uploader,
      SelectCountry,
    },
    computed: {
      ...mapGetters('independentMarketing', ['GET_COUNTRY_LIST', 'GET_SELECT_COUNTRY']),
      confirmBtnDisabled() {
        for (let key in this.form) {
          let item = this.form[key];
          if (!item.trim()) {
            return true;
          }
        }
        return !this.GET_SELECT_COUNTRY || !this.idCard.length || !this.companyCard.length || !!this.emailErrorMsg;
      },
    },
    data() {
      return {
        form: {
          companyName: '',
          dutyParagraph: '',
          name: '',
          email: '',
        },
        emailErrorMsg: '',
        idCard: [],
        companyCard: [],
      };
    },
    created() {
      this.getCountryList();
    },
    mounted() {
      this.uploadDomNoTitle();
    },
    methods: {
      ...mapActions('independentMarketing', ['POST_COUNTRY_LIST']),
      uploadDomNoTitle() {
        const uploadDomArr = document.querySelectorAll('.van-uploader__input');
        uploadDomArr.forEach(item => {
          item.setAttribute('title', ' ');
        });
      },
      checkEmail(val) {
        const reg =
          /^(?=.{6,320}$)((\w[\w\.\-\_]{1,62}\w)|(\w{1,64}))@[A-Za-z0-9]+((\.|-|_)[A-Za-z0-9]+)*\.[A-Za-z0-9]+$/;
        if (!reg.test(val)) {
          this.emailErrorMsg = this.i18n.independentMarketing.emailErrorTips;
        } else {
          this.emailErrorMsg = '';
        }
      },
      changeIdCard(list) {
        this.idCard = [...list];
        this.$nextTick(() => {
          this.uploadDomNoTitle();
        });
      },
      changeCompanyCard(list) {
        this.companyCard = [...list];
        this.$nextTick(() => {
          this.uploadDomNoTitle();
        });
      },
      confirm() {
        if (this.confirmBtnDisabled) return;
        const params = this.formParamHandler();
        console.log(params);
        this.$showLoading();
        applyApi(params)
          .then(res => {
            const { code, data, message } = res;
            if (code == 200) {
              this.$router.push(`/independent-marketing/success?email=${params.email}`);
            } else {
              this.$showToast(message || this.i18n.independentMarketing.agreement.getAgreementFailed);
            }
          })
          .catch(err => {
            this.$showToast(err?.message || this.i18n.independentMarketing.agreement.getAgreementFailed);
          })
          .finally(() => {
            this.$hideLoading();
          });
      },
      formParamHandler() {
        const { companyName, dutyParagraph, name, email } = this.form;
        return {
          companyName,
          email,
          companyVatNumber: dutyParagraph,
          countryId: this.GET_SELECT_COUNTRY.countryCode,
          companyOwnerName: name,
          companyOwnerPathId: this.idCard[0]?.id,
          companyBusinessLicenseId: this.companyCard[0]?.id,
          timeZone: new Date().getTimezoneOffset() / 60,
        };
      },
      cancel() {
        this.$router.push('/independent-marketing/agreement');
      },
      getCountryList() {
        if (this.GET_COUNTRY_LIST?.length) return;
        this.POST_COUNTRY_LIST();
      },
    },
  };
</script>
<style lang="less" scoped>
.apply-form-page.pcStyle {
  height: 100%;
  box-sizing: border-box;
  .apply-form-content {
    background: #f8f9fa;
  }
  .page-content {
    .content-title {
      font-size: 24px;
      font-weight: bold;
      color: #303030;
      margin-top: 60px;
      margin-bottom: 30px;
      text-align: center;
    }
  }
  .form-component {
    overflow: hidden;
    .form-item {
      margin-bottom: 30px;
      .title {
        font-size: 16px;
        color: #303030;
        margin-bottom: 16px;
        .required {
          color: #e02020;
          margin-right: 4px;
        }
      }
      .text-tips {
        color: #888;
        font-size: 16px;
        margin-top: 10px;
      }
      .error-tips {
        color: #f00;
        font-size: 14px;
        margin-top: 4px;
      }
      .van-cell::after {
        display: none;
      }
      &.error {
        /deep/ .van-field__control {
          border-color: #f00;
        }
      }
    }
    .country-item {
      .van-cell {
        overflow: visible;
      }
      .form-item-value {
        width: 100%;
      }
    }
  }

  .footer-btn {
    margin-top: 70px;
    text-align: center;
    margin-bottom: 70px;
    .common-btn {
      min-width: 176px;
      height: 48px;
      background: #e0121b;
      border-radius: 6px;
      border: 1px solid #e0121b;
      color: #fff;
      font-size: 20px;
      cursor: pointer;
      &.cancel {
        border-color: #303030;
        background: #fff;
        color: #303030;
      }
      &:active {
        opacity: 0.8;
      }
      &:disabled {
        opacity: 0.5;
        cursor: not-allowed;
      }
    }
  }
  .mr16 {
    margin-right: 16px;
  }
  .w50 {
    width: 50%;
    display: inline-block;
  }
}
</style>